import { isProd } from './isProd'

export const getLogoutLink = (): string => {
    if (isProd()) {
        return 'https://partners.auth.lemanapro.ru/realms/partner/protocol/openid-connect/logout?client_id=2aa2e1efe35245b485fadcb1a34dcd4c&post_logout_redirect_uri='
    }

    return 'https://internal-partners-preprod.auth.lmru.tech/realms/partner/protocol/openid-connect/logout?client_id=e5228b5481274b5e8db38f181e7ae3b4&post_logout_redirect_uri='
}
